module.exports = __webpack_public_path__ + "static/venice20894-2ad336f2e48f9fc7d16a37d4a867caaf.png";